import type { StepChangeEvent } from '../types';

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

/**
 * Default step-change analytics. Pushes to GTM's dataLayer — the legacy
 * ga('send', ...) virtual-pageview calls are dead (UA retired, site is
 * GTM-only). See docs/calculator-engine-architecture.md §16 Q3.
 *
 * A calculator can override this entirely via CalculatorConfig.onStepChange.
 */
export function pushStepChangeToDataLayer(evt: StepChangeEvent): void {
  if (typeof window === 'undefined') return;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'calculator_step',
    calculator_id: evt.calculatorId,
    step_id: evt.stepId,
    step_index: evt.stepIndex,
    step_count: evt.stepCount,
  });
}
